import { api } from "./client";

export type Role = "admin" | "registrar" | "doctor" | "lab_tech" | "chief_doctor" | "medical_commission";
export type DoctorSpecialty =
  | "therapist"
  | "neurologist"
  | "ophthalmologist"
  | "ent"
  | "surgeon"
  | "gynecologist"
  | "urologist"
  | "dentist"
  | "psychiatrist_narcologist"
  | "dermatovenerologist"
  | "cardiologist"
  | "radiologist"
  | "laboratory";

export interface UserRead {
  id: string;
  clinic_id: string;
  email: string;
  full_name: string;
  role: Role;
  specialty: DoctorSpecialty | null;
  is_active: boolean;
  must_change_password: boolean;
  last_login_at: string | null;
  created_at: string;
  rate_per_section?: number | null;
  monthly_base?: number | null;
  rate_currency?: string;
}

export interface UserList {
  items: UserRead[];
  total: number;
  limit: number;
  offset: number;
}

export interface UserCreatePayload {
  email: string;
  full_name: string;
  role: Role;
  specialty?: DoctorSpecialty | null;
  initial_password: string;
}

export interface UserUpdatePayload {
  full_name?: string;
  role?: Role;
  specialty?: DoctorSpecialty | null;
  is_active?: boolean;
  rate_per_section?: number | null;
  monthly_base?: number | null;
  rate_currency?: string;
}

export async function listUsers(params: {
  role?: Role;
  q?: string;
  is_active?: boolean;
  limit?: number;
  offset?: number;
}): Promise<UserList> {
  const { data } = await api.get<UserList>("/users", { params });
  return data;
}

export async function createUser(payload: UserCreatePayload): Promise<UserRead> {
  const { data } = await api.post<UserRead>("/users", payload);
  return data;
}

export async function updateUser(id: string, payload: UserUpdatePayload): Promise<UserRead> {
  const { data } = await api.patch<UserRead>(`/users/${id}`, payload);
  return data;
}

export async function deactivateUser(id: string): Promise<void> {
  await api.delete(`/users/${id}`);
}

export async function resetUserPassword(id: string): Promise<{ temporary_password: string }> {
  const { data } = await api.post<{ temporary_password: string }>(
    `/users/${id}/reset-password`,
  );
  return data;
}
